import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { CustomTextField } from "../SearchTextField/SearchTextField";
import useGetData from "../../../Hooks/useGetData";
import { Controller } from "react-hook-form";

const CountrySelect = ({ control, name, setCountryId }) => {
  const { t, i18n } = useTranslation();
  // Fetch area data from the API using a custom hook
  const { data, loading } = useGetData("address/get/country", []);
  // Define the menus state and update it based on the fetched data and the current language
  const [menus, setMenus] = useState([]);
  useEffect(() => {
    if (data) {
      setMenus([]);
      data?.countries?.map((country) => {
        setMenus((prev) => [
          ...prev,
          {
            label:
              i18n.language === "ar"
                ? country.name_ar || country?.name_en
                : country?.name_en || country?.name_ar,
            id: country.id,
            ship_cost: country.ship_cost,
          },
        ]);
      });
    }
  }, [data, i18n.language]);
  if (!data) return null;
  return (
    <Controller
      name={name}
      control={control}
      // defaultValue={""}
      // defaultValue={disabled && ""}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          disablePortal
          fullWidth
          onChange={(e, newValue) => {
            field.onChange(newValue ? newValue.id : "");
            setCountryId(newValue ? newValue.id : "");
          }}
          isOptionEqualToValue={(option, value) => option === value}
          value={
            menus.find((item) => {
              return item.id === field.value;
            }) || ""
          }
          sx={{
            "& .MuiInput-input": {
              fontSize: "1.5rem",
            },
            "& .MuiSvgIcon-root": {
              color: !!error ? "red" : "white",
            },
          }}
          ListboxProps={{
            sx: {
              "&::-webkit-scrollbar": {
                width: "0.4em",
              },
              "&::-webkit-scrollbar-track": {
                background: "#f1f1f1",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#3db9ec",
                borderRadius: "20px",
              },
              "& li": {
                fontSize: "1.5rem",
                fontWeight: "400",
                color: "#755798",
                position: "relative",
              },
            },
          }}
          id="country_id"
          options={menus}
          title="country_id"
          loading={loading}
          getOptionLabel={(option) => (option.label ? option.label : "")}
          renderInput={(params) => (
            <CustomTextField
              helperText={!!error && error.message}
              error={!!error}
              fullWidth
              {...params}
              label={t("profile.addressForm.country")}
              variant="standard"
            />
          )}
        />
      )}
    />
  );
};

export default React.memo(CountrySelect);
